<header>
    <div class="float-start kpmg-log">
        <img src="../../assets/images/kpmg-logo.svg" routerLink="/" style="cursor: pointer;" />
        <span class="vr"></span>
        <span class="bmp-header-txt">{{commonService.moduleName | async}}</span>
    </div>
    <div class="float-end">
        <div class="d-flex align-items-center justify-content-between">
          <div class="dropdown me-2"  *ngIf="!(commonService.$disclaimerDenied | async) && (reports.length > 0)">
            <button class="btn btn-secondary dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false" style="font-size: 0.875rem; background-color: transparent; border-color: #fff;">
              {{ getSelectedReportName() }}
            </button>
            <ul class="dropdown-menu">
              <li *ngFor="let report of reports"><a class="dropdown-item" (click)="onReportSelect(report.id)" style="font-size:0.875rem;">{{ report?.name }}</a></li>
            </ul>
          <span class="text-danger ms-1">*</span>
          </div>
          <div class="btn-group" ngbDropdown >
            <button ngbDropdownToggle type="button" class="btn btn-primary  dropdown-toggle">
               {{userService.$authState()?.name}}<span class="caret"></span>
            </button>
            <ul ngbDropdownMenu  class="dropdown-menu" role="menu">
              <li role="menuitem"><a class="dropdown-item fw-semibold" href="#">{{userService.$authState()?.username}}</a>
                <li class="divider dropdown-divider"></li>
              <!--<li role="menuitem"><a class="dropdown-item" href="#">My Info</a>-->
              <li role="menuitem"><a style="cursor:pointer" class="dropdown-item" (click)="logout()">Logout</a>
              </li>
            </ul>
          </div>
       </div>
        <!-- <a routerLink="/admin"><img src="../../assets/images/setting-icon.svg"  class="setting" /></a> -->
        <!-- <img src="../../assets/images/avatar-icon.svg" /> -->
        
    </div>
</header>

